module.exports = __webpack_public_path__ + "static/ee-exp-365236bb58c45ef28715ee1f6952f8b4.svg";